// src/utils/clientStorage.mjs
// Sistema de gerenciamento de storage para ID do cliente

const CLIENT_ID_KEY = 'comunicabot_client_id';
const CLIENT_NAME_KEY = 'comunicabot_client_name';

export const setClientData = (clientId, clientName) => {
    localStorage.setItem(CLIENT_ID_KEY, clientId.toString());
    localStorage.setItem(CLIENT_NAME_KEY, clientName);
};

export const getClientId = () => {
    return localStorage.getItem(CLIENT_ID_KEY);
};

export const getClientName = () => {
    return localStorage.getItem(CLIENT_NAME_KEY);
};

export const clearClientData = () => {
    localStorage.removeItem(CLIENT_ID_KEY);
    localStorage.removeItem(CLIENT_NAME_KEY);
};

export const hasClientData = () => {
    return !!getClientId();
};
